import styled, {css} from 'styled-components';

export const STalentCategories = styled.div`
  ${({theme}) => css`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 50%;
    .categories-list {
      height: 100%;
      position: relative;
      overflow: auto;
      display: flex;
      flex-direction: column;
      ${theme.Presets.scroll}
      .categories-item {
        display: flex;
        align-items: center;
        padding: 3px;
        border-bottom: 1px solid ${theme.Color.GrayLight};
        &:hover {
          background-color: #efefef;
          img {
            visibility: visible;
            cursor: pointer;
          }
        }
        img {
          height: 13px;
          width: 13px;
          visibility: hidden;
          margin-right: 3px;
        }
      }
    }
  `}
`;
